import { restApiActions } from 'redux/redux-actions';

export const goodsUploadImageActions = restApiActions('goods', 'upload-image');
export const goodsImageActions = restApiActions('goods', 'remove-image');
export default restApiActions('goods');
